import React, { useState } from 'react';

import { CircularProgress } from '@material-ui/core';
import { useSnackbar } from 'notistack';

import ConfirmationModal from '../../components/common/ConfirmationModal';
import { ACTIONS } from '../../constants/logs';
import LogService from '../../services/log.service';
import UserService from '../../services/user.service';

export default ({ open, onClose, user, action, onStatusChanged }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const userService = new UserService();

  const isDisableAction = action === 'disable';
  const actionVerb = isDisableAction ? 'disable' : 'enable';
  const actionPastTense = isDisableAction ? 'disabled' : 'enabled';

  const handleUpdateStatus = async () => {
    if (!user || !user.id) return;

    try {
      setIsSubmitting(true);

      if (isDisableAction) {
        await userService.disableUser(user.id);
      } else {
        await userService.enableUser(user.id);
      }

      enqueueSnackbar(`User ${actionPastTense} successfully`, { variant: 'success' });

      if (onStatusChanged) {
        onStatusChanged();
      }

      onClose();
    } catch (error) {
      console.error(`Error ${actionVerb}ing user:`, error);
      enqueueSnackbar(error.message || `Failed to ${actionVerb} user`, { variant: 'error' });
    } finally {
      setIsSubmitting(false);
    }
  };

  const submitButtonLabel = isDisableAction ? 'Disable User' : 'Enable User';

  const confirmText = isSubmitting ? (
    <>
      <CircularProgress size={20} color="inherit" style={{ marginRight: 8 }} />
      Processing...
    </>
  ) : (
    submitButtonLabel
  );

  const message = isDisableAction ? (
    <span>
      Are you sure you want to disable <b>{user?.name}</b>&apos;s account? He/She will no longer be able to log in.
    </span>
  ) : (
    <span>
      Are you sure you want to enable <b>{user?.name}</b>&apos;s account? He/She will be able to log in again.
    </span>
  );

  return (
    <ConfirmationModal
      open={open}
      onCancel={onClose}
      onConfirm={handleUpdateStatus}
      title={isDisableAction ? 'Disable User Account' : 'Enable User Account'}
      message={message}
      confirmText={confirmText}
      cancelText="Cancel"
    />
  );
};
